import { Component, OnInit} from '@angular/core';
import { HeaderService } from '../Services/header.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['../app.component.scss']
})
export class AlertComponent implements OnInit {
  constructor(private headerService: HeaderService) {}

  alerts = [];
  subscription: Subscription;

  closeAlert(a: any) {
    this.headerService.closeAlert(a);
  }

  ngOnInit() {
    this.subscription = this.headerService.alertsPushed$.subscribe(
      a => {
        this.alerts = a;
    });
  }
}
